let $injector: angular.auto.IInjectorService | null = null;

export const getInjector = () => $injector;

export const _setInjector = ($i: angular.auto.IInjectorService) => ($injector = $i);
